import ReactDOM from 'react-dom';
import React, { Component } from 'react'

import IndexUI from "./IndexUI";

class BubbleDemo extends  Component{
    constructor() {
        super();
    }

    render(){
        return(<IndexUI></IndexUI>)
    }
}

export default BubbleDemo